import React, { Fragment, useState } from 'react';
import List from "@mui/material/List";
import ListItem from "@mui/material/List";
import Collapse from "@mui/material/Collapse";
import { Link } from "react-router-dom";

const menus = [
    {
        id: 1,
        title: 'Home',
        link: '/',
    },
    {
        id: 3,
        title: 'Company',
        link: '/',
        submenu: [
            {
                id: 31,
                title: 'About Us',
                link: '/about'
            },
            {
                id: 3459,
                title: 'Terms & Conditions',
                link: '/terms-conditions'
            },
            {
                id: 3460,
                title: 'Privacy Policy',
                link: '/privacy-policy'
            }
        ]
    },
    {
        id: 5,
        title: 'Services',
        link: '/service',
        submenu: [
            { id: 51, title: 'Services', link: '/service' },
            { id: 52, title: 'Shopify', link: '' },
            { id: 53, title: 'Magento', link: '' },
            { id: 54, title: 'Odoo Implementation', link: '' },
            { id: 55, title: 'PIM', link: '' },
            { id: 56, title: 'Akeneo', link: '' },
            { id: 57, title: 'React Native', link: '' },
            { id: 58, title: 'Flutter', link: '' },
            { id: 59, title: 'React Web Apps', link: '' },
            { id: 60, title: 'Data Analytics', link: '' },
            { id: 61, title: 'SAP', link: '' },
            { id: 62, title: 'Headless Website', link: '' },
            { id: 63, title: 'Cloud Infrastructure', link: '' }
        ]
    },
    {
        id: 7,
        title: 'Casestudy',
        link: '/casestudy',
        submenu: [
            { id: 71, title: 'Casestudy', link: '/casestudy' }
        ]
    },
    {
        id: 88,
        title: 'Contact',
        link: '/contact'
    }
]
const MobileMenu = () => {

    const [openId, setOpenId] = useState(0);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <ul className="xb-menu-primary clearfix">
            {menus.map((item, mn) => {
                return (
                    <ListItem className={item.id === openId ? 'active' : null} key={mn}>
                        {item.submenu ?
                            <Fragment>
                                <p onClick={() => setOpenId(item.id === openId ? 0 : item.id)}>{item.title}
                                    <i className={item.id === openId ? 'fa fa-angle-up' : 'fa fa-angle-down'}></i>
                                </p>
                                <Collapse in={item.id === openId} timeout="auto" unmountOnExit>
                                    <List className="menu-item menu-item-has-children active">
                                        <Fragment>
                                            {item.submenu.map((submenu, i) => {
                                                return (
                                                    <ListItem key={i}>
                                                        <Link onClick={ClickHandler} className="active"
                                                            to={submenu.link}>{submenu.title}</Link>
                                                    </ListItem>
                                                )
                                            })}
                                        </Fragment>
                                    </List>
                                </Collapse>
                            </Fragment>
                            : <Link className="active"
                                to={item.link}>{item.title}</Link>
                        }
                    </ListItem>
                )
            })}
        </ul>
    )
}

export default MobileMenu;